export const allPropertiesEmpty = (obj) => {
  for (const key in obj) {
    if (typeof obj[key] === 'object') {
      if (!allPropertiesEmpty(obj[key])) {
        return false;
      }
    } else if (obj[key] !== '' && obj[key] !== null && obj[key] !== undefined) {
      return false;
    }
  }
  return true;
}